import { createContext } from 'react';

export const ComponentsContext = createContext({ subscriptionIsActive: false });
